import { createQueryKeyFactory } from '@/utils/queries'
import type { Ref } from 'vue'

const profileMergeQueryKeys = createQueryKeyFactory(['profileMerge'])

export default {
    ...profileMergeQueryKeys,
    polling: (id: Ref<number | null>) => [...profileMergeQueryKeys.all, 'polling', id]
}
